import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'NightWolf_AR',
  rank: 'Heroico → Gran Maestro',
  text: 'Pensé que era otro PDF más de tips random. Me equivoqué. En 4 días ya estaba jugando diferente, tomando mejores decisiones y ganando 1v1 que antes perdía siempre.',
  stars: 5
}, {
  name: 'Mati_Clutch',
  rank: 'Diamante IV → Heroico',
  text: 'Lo de la configuración PRO me voló la cabeza. Cambié la sensibilidad como dice el ebook y fue un antes y un después. Ahora mis amigos me piden que les pase la config.',
  stars: 5
}, {
  name: 'LaFlacaFF',
  rank: 'Platino → Diamante II',
  text: 'Soy mujer y siempre me subestimaban en ranked. Apliqué el sistema de posicionamiento y ahora cierro partidas que antes ni soñaba. Mejor compra que hice.',
  stars: 5
}, {
  name: 'ElPibe_Ranked',
  rank: 'Oro III → Diamante',
  text: 'Estaba re estancado en Oro hace meses. Seguí la rutina de 7 días al pie de la letra y subí a Diamante en 6 días. No lo podía creer.',
  stars: 5
}, {
  name: 'ToxicSniper99',
  rank: 'Heroico',
  text: 'Lo mejor es la parte de cuándo atacar y cuándo esperar. Yo siempre rusheaba como loco y moría primero. Ahora soy el último en pie casi siempre. Vale cada peso.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-gamer-dark relative overflow-hidden" data-id="element-204">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gamer-red/5 rounded-full blur-[120px] pointer-events-none" data-id="element-205"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-207">
          <span className="text-gamer-red font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-208">
            Prueba social
          </span>
          <h2 className="text-3xl md:text-5xl font-orbitron font-bold text-white" data-id="element-209">
            Ellos ya <span className="text-gamer-red" data-id="element-210">dominan</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-211">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-[#111111] border border-white/5 rounded-xl p-6 flex flex-col justify-between ${index === 0 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-212">
              {/* Stars */}
              <div data-id="element-213">
                <div className="flex gap-1 mb-4" data-id="element-214">
                  {Array.from({
                length: t.stars
              }).map((_, i) => <Star key={i} className="w-4 h-4 fill-gamer-yellow text-gamer-yellow" data-id="element-215" />)}
                </div>

                {/* Quote */}
                <p className="text-gray-300 font-inter leading-relaxed text-[15px] mb-6" data-id="element-216">
                  "{t.text}"
                </p>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-217">
                {/* Avatar placeholder */}
                <div className="w-10 h-10 rounded-full bg-gamer-red/20 border border-gamer-red/30 flex items-center justify-center flex-shrink-0" data-id="element-218">
                  <span className="text-gamer-red font-orbitron font-bold text-sm" data-id="element-219">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-220">
                  <p className="text-white font-bold font-orbitron text-sm" data-id="element-221">
                    {t.name}
                  </p>
                  <p className="text-gamer-red text-xs font-inter" data-id="element-222">{t.rank}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}